/**
 * Gets the bounds of a circle with the specified distance and center coordinates.
 */
export const getBounds = ({ distance, center, maps, }) => {
    const circle = new maps.Circle({
        radius: distance,
        center,
    });
    return circle.getBounds();
};
